import useMediaQuery from '@mui/material/useMediaQuery';
import { useFieldNames } from 'components/new-order/useFieldNames.hooks';
import RHFDevtoolsWrapper from 'components/rhf-devtools-wrapper/rhf-devtools-wrapper.component';
import { useLoginLink } from 'hooks/useLoginLink';
import { OrderTypeContext } from 'pages/store/new-order-form/order-form-context';
import React, { useEffect, useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import DelayedRender from 'components/delayed-render/delayed-render.component';
import LocationsFinder from './locations-finder/locations-finder.component';
import * as S from './locations.styles';
import LocationsMapMapbox from './locations-map-mapbox/locations-map-mapbox.component';

const LocationsPage = () => {
  const [selectedStore, setSelectedStore] = useState(null);
  const [switchingPickupStoreId, setSwitchingPickupStoreId] = useState(null);
  const matches = useMediaQuery(theme => theme.breakpoints.up('sm'));
  const { state } = useLocation();
  const { redirected } = state || {};
  const formMethods = useForm({ shouldUnregister: true });
  const { fieldNames } = useFieldNames();
  const cateringOrderType = formMethods.watch(fieldNames.cateringOrderType);
  const orderType = formMethods.watch(fieldNames.orderType);
  const orderTypeContextValue = useMemo(
    () => (orderType === 'CATERING' ? cateringOrderType : orderType),
    [cateringOrderType, orderType],
  );
  const handleLoginLinkClick = useLoginLink();

  useEffect(() => {
    if (redirected) {
      handleLoginLinkClick();
      window.history.replaceState({ ...state, redirected: false }, '');
    }
  }, [handleLoginLinkClick, redirected, state]);

  return (
    <S.Container>
      <FormProvider {...formMethods}>
        <OrderTypeContext.Provider value={orderTypeContextValue}>
          <LocationsFinder
            selectedStore={selectedStore}
            setSelectedStore={setSelectedStore}
            orderType={orderType}
            switchingPickupStoreId={switchingPickupStoreId}
            setSwitchingPickupStoreId={setSwitchingPickupStoreId}
          />
          {matches && (
            <Box flexGrow={1} order={2} data-testid="LocationsMap.Container">
              <DelayedRender>
                <LocationsMapMapbox
                  setSelectedStore={setSelectedStore}
                  selectedStore={selectedStore}
                />
              </DelayedRender>
            </Box>
          )}
        </OrderTypeContext.Provider>
        <RHFDevtoolsWrapper control={formMethods.control} />
      </FormProvider>
    </S.Container>
  );
};

export default LocationsPage;
